module.exports = __webpack_public_path__ + "img/이을 아티스트.5ccfac4d.jpg";